import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';

import { userLogout, forbiddenAccess } from './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getTextNumberSuccess({ textNumber }) {
  return {
    type: types.GET_TEXT_NUMBER_SUCCESS,
    textNumber,
  };
}

export function getTextNumberFail() {
  return {
    type: types.GET_TEXT_NUMBER_FAIL,
  };
}

export function testCallForwardStart({ req }) {
  return {
    type: types.TEXT_CALLFORWARD_START,
    req,
  };
}

export function testCallForwardSuccess() {
  return {
    type: types.TEXT_CALLFORWARD_SUCCESS,
  };
}

export function testCallForwardFail() {
  return {
    type: types.TEXT_CALLFORWARD_FAIL,
  };
}

export function getTextNumber() {
  return (dispatch) => {
    request.get(`${window.Config.API_URL}/business/textNumber`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getTextNumberSuccess({ textNumber: resp.body.data.phone }));
        } else {
          dispatch(getTextNumberFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getTextNumberFail());
      });
  };
}

export function getTextCallForwardVerify() {
  return (dispatch, getState) => {
    const { auth } = getState();
    const params = Object.assign({}, {
      query: auth.userid,
    });

    const req = request.get(`${window.Config.API_URL}/twiliocall/testCallForward`).withCredentials().set('X-Request-ID', uuidv4())
      .query(params);

    req
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(testCallForwardSuccess());
        } else {
          dispatch(testCallForwardFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(testCallForwardFail());
      });

    dispatch(testCallForwardStart({ req }));
  };
}

export function abortTextCallForwardVerify() {
  return (dispatch, getState) => {
    const { carriers } = getState();

    if (carriers.callForwardRequest) {
      // Abort request and fail
      carriers.callForwardRequest.abort();

      dispatch(testCallForwardFail());
    }
  };
}

/* ========= getNewPhoneNumber API ========= */

const getNewPhoneNumberStart = () => ({
  type: types.GET_NEW_PHONE_NUMBER_START,
});

const getNewPhoneNumberSuccess = (newPhoneNumber) => ({
  type: types.GET_NEW_PHONE_NUMBER_SUCCESS,
  newPhoneNumber,
});

const getNewPhoneNumberFail = (errorMessage) => ({
  type: types.GET_NEW_PHONE_NUMBER_FAIL,
  errorMessage,
});

export function getNewPhoneNumber(params) {
  return (dispatch) => {
    dispatch(getNewPhoneNumberStart());
    request
      .post(`${window.Config.API_URL}/business/settings/new-number`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .ok((resp) => resp.status >= 200 && resp.status < 500)
      .then((resp) => {
        const data = resp?.body;
        if (resp.statusCode === 200) {
          dispatch(getNewPhoneNumberSuccess(data?.data?.purchased_number));
        } else {
          dispatch(getNewPhoneNumberFail(data?.message));
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(getNewPhoneNumberFail('Something went wrong'));
      });
  };
}

export function clearErrorMessage() {
  return (dispatch) => {
    dispatch({ type: types.GET_NEW_PHONE_NUMBER_CLEAR });
  };
}

/* ========= migrateToWeave API ========= */

const migrateToWeaveStart = () => ({
  type: types.MIGRATE_TO_WEAVE_START,
});

const migrateToWeaveSuccess = (data) => ({
  type: types.MIGRATE_TO_WEAVE_SUCCESS,
  data,
});

const migrateToWeaveFail = (data) => ({
  type: types.MIGRATE_TO_WEAVE_FAIL,
  data,
});

export function migrateToWeave(params) {
  return (dispatch) => {
    dispatch(migrateToWeaveStart());
    request
      .post(`${window.Config.API_URL}/business/weave/v1/fusion/migrate`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .ok((resp) => resp.status < 501)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(userLogout());
          dispatch(migrateToWeaveSuccess(data));
        } else {
          const data = JSON.parse(resp.text);
          console.log('migrateToWeave', data);
          dispatch(migrateToWeaveFail(data));
        }
      })
      .catch((ex) => {
        console.log('migrateToWeave', ex);
        dispatch(migrateToWeaveFail());
      });
  };
}

/* ========= updateWeaveInfo API ========= */

const updateWeaveInfoStart = () => ({
  type: types.UPDATE_WEAVE_INFO_START,
});

const updateWeaveInfoSuccess = (data) => ({
  type: types.UPDATE_WEAVE_INFO_SUCCESS,
  data,
});

const updateWeaveInfoFail = (data) => ({
  type: types.UPDATE_WEAVE_INFO_FAIL,
  data,
});

export function updateWeaveInfo(params) {
  return (dispatch) => {
    dispatch(updateWeaveInfoStart());
    request
      .post(`${window.Config.API_URL}/business/weave/v1/info`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .ok((resp) => resp.status < 501)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(updateWeaveInfoSuccess(data));
        } else {
          const data = JSON.parse(resp.text);
          dispatch(updateWeaveInfoFail(data));
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(updateWeaveInfoFail());
      });
  };
}

/* ========= canMigrateToWeave API ========= */

const canMigrateToWeaveStart = () => ({
  type: types.CAN_MIGRATE_TO_WEAVE_START,
});

const canMigrateToWeaveSuccess = (data) => ({
  type: types.CAN_MIGRATE_TO_WEAVE_SUCCESS,
  data,
});

const canMigrateToWeaveFail = () => ({
  type: types.CAN_MIGRATE_TO_WEAVE_FAIL,
});

export function canMigrateToWeave() {
  return (dispatch) => {
    dispatch(canMigrateToWeaveStart());
    request
      .get(`${window.Config.API_URL}/business/weave/v1/fusion/eligible`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(canMigrateToWeaveSuccess(data));
        } else {
          dispatch(canMigrateToWeaveFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(canMigrateToWeaveFail());
      });
  };
}
